import handlebars from "handlebars";

/**
 * Register custom Handlebars helpers
 */

// Helper to increment a value (useful for question numbers)
handlebars.registerHelper("increment", function (value) {
    return parseInt(value) + 1;
});

// Helper for conditional logic with operators
handlebars.registerHelper("ifCond", function (v1, operator, v2, options) {
    switch (operator) {
        case "==":
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case "===":
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case "!=":
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case "!==":
            return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case "<":
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case "<=":
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case ">":
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case ">=":
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case "&&":
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case "||":
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
});

// Helper to provide default values
handlebars.registerHelper("default", function (value, defaultValue) {
    return value || defaultValue;
});

/**
 * Compile template by ID and render with data
 * @param {string} templateId - The ID of the script template element
 * @param {object} data - The data to pass to the template
 * @returns {string} Rendered HTML
 */
export function compileTemplate(templateId, data) {
    const templateSource = document.getElementById(templateId);
    if (!templateSource) {
        console.error('Template not found:', templateId);
        return '';
    }
    
    const template = handlebars.compile(templateSource.innerHTML);
    return template(data);
}

/**
 * Alternative: Compile from HTML string
 * @param {string} htmlTemplate - The HTML template string
 * @param {object} data - The data to pass to the template
 * @returns {string} Rendered HTML
 */
export const compile = (htmlTemplate, data) => {
    const template = handlebars.compile(htmlTemplate);
    return template(data);
};

export default compileTemplate;
